export default "__VITE_ASSET__d83JnWQM__"